import React, { FC, useEffect } from "react";
import Alert from "../../Components/Shell/Alert";
import { withAlertContext } from "../../Context/Alerts";
import { withTermoContext } from "../../Context/Termos";
import { MainSwitch } from "./MainSwitch";
import { ShellHostContainer } from "./ShellHost.styles";

export const IuguService = (window as any).Iugu as {
  setAccountID: (id: string) => void;
  setTestMode: (testMode: boolean) => void;
  createPaymentToken: (
    values: any,
    callBack: (response: { errors?: string; id?: string }) => void
  ) => void;
  CreditCard: (
    number: string,
    mes: string,
    ano: string,
    first_name: string,
    last_name: string,
    cvv: string
  ) => any;
  utils: {
    getBrandByCreditCardNumber: (number: string) => string | boolean;
    validateExpiration: (mes: number, ano: number) => boolean;
    validateExpirationString: (expirity: string) => boolean;
    validateCVV: (cvv: string, brand: string) => boolean;
    validateCreditCardNumber: (number: string) => boolean;
  };
};

export interface IShellHost {}

const ShellHost: FC<IShellHost> = (props) => {
  useEffect(() => {
    IuguService.setAccountID("073DD51E0D9A42AD8DD4F15139DE57B8");
    if (
      window.location.href.includes("homolog") ||
      window.location.href.includes("localhost")
    ) {
      console.log("IU GU Test mode Enabled");
      IuguService.setTestMode(true);
    }
  }, []);

  return (
    <ShellHostContainer>
      <Alert />
      <MainSwitch />
    </ShellHostContainer>
  );
};

export default withAlertContext(withTermoContext(ShellHost));
